import moment from "moment";
import React from "react";
import { Alert, Container } from "reactstrap";
import { useClaimPhotoDates } from "../../api/main/claims/useClaimPhotoDates";
import { useCurrentClaimId } from "../../api/main/claims/useCurrentClaimId";
import { useGetInspectionPhotos } from "../../api/main/claims/useGetInspectionPhotosCallback";
import { AlertOnErrors } from "../../shared/alertOnErrors";
import { PageSection } from "../../shared/pageSection/PageSection";
//import { useZipBlobCallback } from "../../shared/useZipData";
import { GalleryImage } from "../shared/GalleryImage";
import { LoadingComponent } from "../shared/LoadingComponent";
import { TrackedClaimContainer } from "../shared/TrackedClaimContainer";
import './photos.scss';
import { ConditionalFragment } from "../../shared/conditionalFragment/index";



export function Photos() {

    const [showPlaceholders, setShowPlaceholders] = React.useState<boolean>(false);
    // get inspection photos from server
    const claimId = useCurrentClaimId();
    const { photos, loading: isLoading, errors } = useGetInspectionPhotos(claimId);
    // get inspection date
    const { data: { item }, errors: claimErrors, isLoading: claimIsLoading } = useClaimPhotoDates({ id: claimId });

    // zip callback
    //const [zipPhotos, { errors: zipErrors, isExecuting: isZipping }] = useZipBlobCallback();

    //function downloadBlob(blob: Blob) {
    //    const url = URL.createObjectURL(blob);

    //    const a = document.createElement("a");
    //    a.href = url;
    //    a.download = "inspection_photos";
    //    document.body.appendChild(a)
    //    a.click();
    //    document.body.removeChild(a)

    //    URL.revokeObjectURL(url);
    //}

    React.useEffect(() => {
        setShowPlaceholders(isLoading && Object.keys(photos).length === 0);
    }, [photos, isLoading]);

    return (
        <TrackedClaimContainer className={"photos"}>
            <PageSection>
                <AlertOnErrors errors={[errors, claimErrors]} />
                <LoadingComponent isLoading={isLoading || claimIsLoading}>
                    <h1>{"Device Photos"}</h1>
                </LoadingComponent>
                {/* if loading and have no cached data, show placeholders */}
                {showPlaceholders ? (
                    <Container fluid className={"photo-gallery"}>
                        {Array.from({ length: 9 }).map((_, index) => {
                            return <GalleryImage
                                alt={"placeholder"}
                                placeholder={true}
                                key={index}
                            />
                        })}
                    </Container>
                ) :
                    /* if loaded and have no data, show message */
                    Object.keys(photos).length === 0 ? (
                        <Alert color={"secondary"}>{"Photos for this claim have not yet been taken."}</Alert>
                    ) : (
                            /* if we have data, show pictures*/
                            <>
                                <ConditionalFragment showIf={Object.entries(photos).filter(([name, url], index) => url.toLocaleLowerCase().includes("received")).length > 0}>
                                    <h2>{"Equipment Received"}</h2>
                                    <div className={"inspection-date"}>
                                        {
                                            item?.equipmentReceived?.eventDate ?
                                                `Equipment Received photos added ${moment(item.equipmentReceived.eventDate).format("DD/MM/YYYY")}`
                                                : ""
                                        }
                                    </div>

                                    <Container fluid className={"photo-gallery"}>
                                        {Object.entries(photos).map(([name, url], index) => {
                                            if (url.toLocaleLowerCase().includes("received")) {
                                                return <GalleryImage
                                                    url={url}
                                                    alt={name}
                                                    key={index}
                                                />
                                            } else {
                                                return <></>
                                            }
                                        })}
                                    </Container>
                                </ConditionalFragment>
                                <ConditionalFragment showIf={Object.entries(photos).filter(([name, url], index) => url.toLocaleLowerCase().includes("inspection")).length > 0}>
                                    <hr />
                                    <h2>{"Inspection"}</h2>
                                    <div className={"inspection-date"}>
                                        {
                                            item?.inspectionStart?.eventDate ?
                                                `Inspection photos added ${moment(item.inspectionStart.eventDate).format("DD/MM/YYYY")}`
                                                : ""
                                        }
                                    </div>

                                    <Container fluid className={"photo-gallery"}>
                                        {Object.entries(photos).map(([name, url], index) => {
                                            if (url.toLocaleLowerCase().includes("inspection")) {
                                                return <GalleryImage
                                                    url={url}
                                                    alt={name}
                                                    key={index}
                                                />
                                            } else {
                                                return <></>
                                            }
                                        })}
                                    </Container>
                                </ConditionalFragment>
                                <ConditionalFragment showIf={Object.entries(photos).filter(([name, url], index) => url.toLocaleLowerCase().includes("repair")).length > 0}>
                                    <hr/>
                                    <h2 style={{marginBottom: "30px" }}>{"Repair"}</h2>
                                    <div className={"inspection-date"}>
                                        {
                                            item?.repairStart?.eventDate ?
                                                `Repair photos added ${moment(item.repairStart.eventDate).format("DD/MM/YYYY")}`
                                                : ""
                                        }
                                    </div>
                                    <Container fluid className={"photo-gallery"}>
                                        {Object.entries(photos).map(([name, url], index) => {
                                            if (url.toLocaleLowerCase().includes("repair")) {
                                                return <GalleryImage
                                                    url={url}
                                                    alt={name}
                                                    key={index}
                                                />
                                            } else {
                                                return <></>
                                            }
                                        })}
                                    </Container>
                                </ConditionalFragment>
                            </>
                        )
                }

            </PageSection>
        </TrackedClaimContainer>
    )

}